$(document).ready(function($){
    // changing position of whatsapp cta when scroll on pdp
  $(window).on('scroll', function() {
    if ($(window).scrollTop() > 600 && $(".stickyCart").length) {
      $('#site-scroll').addClass('scrolled');
    } else {
      $('#site-scroll').removeClass('scrolled');
    }
  });
  // end

  // For single product page current variant should be highlighted
  if($('.related-product')){
    console.log('Yes visible (related-product)');
    let currentUrl = window.location.href;
    let relatedProductsUrl = $('.related-product');
  
    relatedProductsUrl.each((i, prod)=>{
      if(currentUrl == prod.href){
        $(prod).css("border-color", "black");
      }
    });    
  }
  // end

})